import { Post } from "../types/blog";
process.env.NODE_ENV === "development"
  ? "http://localhost:9999/.netlify/functions"
  : "/.netlify/functions"; // ✅ Uses Netlify URL in production
const API_BASE = "/.netlify/functions"; // ✅ Netlify auto-detects functions

/** Fetch all posts */
export async function fetchPosts(): Promise<Post[]> {
  try {
    const response = await fetch(`${API_BASE}/getPosts`); // ✅ Uses Netlify Function
    if (!response.ok) throw new Error("Failed to fetch posts");

    const data = await response.json();
    if (!Array.isArray(data)) throw new Error("Invalid response format");

    return data;
  } catch (error) {
    console.error("❌ Error fetching posts:", error);
    return []; // ✅ Always return an empty array on failure
  }
}

/** Fetch a specific post */
export async function fetchPost(slug: string): Promise<Post | null> {
  try {
    const response = await fetch(`${API_BASE}/getPosts`);
    if (!response.ok) throw new Error("Failed to fetch posts");

    const posts: Post[] = await response.json(); // ✅ Ensure TypeScript knows it's an array of Posts
    const post = posts.find((p: Post) => p.slug === slug);
    if (!post) {
      console.error(`❌ Post with slug "${slug}" not found`);
      throw new Error("Post not found");
    }

    return {
      id: post?.id || "",
      excerpt: post?.excerpt || "",
      title: post?.title || "Untitled",
      slug: post?.slug || slug,
      date: post?.date || new Date().toISOString(),
      description: post?.description || "",
      author: post?.author || "Unknown",
      categories: post?.categories || [],
      image: post?.image || "",
      content: post?.content || "", // ✅ Content is an object
    };
  } catch (error) {
    console.error("❌ Error fetching post:", error);
    return null;
  }
}

/** Send an inquiry form */
export async function sendInquiry(data: any) {
  try {
    const response = await fetch(`${API_BASE}/sendInquiry`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to send inquiry");
    }

    return await response.json();
  } catch (error: any) {
    console.error("❌ Error sending inquiry:", error);
    throw error;
  }
}
